import React from "react";
import { AppGlobals } from "./AppGlobals";

interface LogoutProps {
  onLogout: () => void;
}

const Logout: React.FC<LogoutProps> = ({ onLogout }) => {

  const hasUserTitle = !!AppGlobals.UserTitle;
  const hasCustomerTitle = !!AppGlobals.CustomerTitle;

  return (
    <>
      {(hasUserTitle || hasCustomerTitle) && (
        <>
          {AppGlobals.UserTitle}
          {hasCustomerTitle ? ` (${AppGlobals.CustomerTitle})` : ''}&nbsp;
        </>
      )}
      Build: {AppGlobals.BuildNumber}&nbsp;|&nbsp;
      <span
        onClick={onLogout}
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        Logout
      </span>
    </>
  );
};

export default Logout;
